<div class="container">
    <jjames-card>
        <div class="card-header">
            <h2>Create Parking Operator</h2>
            <p>Add a new parking operator to the system</p>
        </div>

        <!-- Success Message -->
        @if (successMessage) {
        <jjames-alert type="success" [dismissible]="true" (dismiss)="onClearSuccess()">
            {{ successMessage }}
        </jjames-alert>
        }

        <!-- Error Message -->
        @if (errorMessage) {
        <jjames-alert type="error" [dismissible]="true" (dismiss)="onClearError()">
            {{ errorMessage }}
        </jjames-alert>
        }

        <!-- Form -->
        <form [formGroup]="createOperatorForm" (ngSubmit)="onSubmit()" class="operator-form">

            <!-- Customer & Group Selection Section -->
            <div class="form-section">
                <h3 class="section-title">Customer & Access Group</h3>

                <div class="form-row">
                    <div class="form-group full-width">
                        <label for="customerId" class="block text-sm font-medium text-gray-700 mb-2">
                            Customer <span class="text-red-500">*</span>
                        </label>
                        <select id="customerId" formControlName="customerId"
                            class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            [class.border-red-500]="isFieldInvalid('customerId')">
                            <option value="">Select a customer</option>
                            @if (loadingCustomers()) {
                            <option disabled>Loading customers...</option>
                            }
                            @for (customer of customers(); track customer.id) {
                            <option [value]="customer.id">{{ customer.name }}</option>
                            }
                        </select>
                        @if (isFieldInvalid('customerId')) {
                        <p class="mt-1 text-sm text-red-600">{{ getFieldError('customerId') }}</p>
                        }
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group full-width">
                        <label for="operatorGroupId" class="block text-sm font-medium text-gray-700 mb-2">
                            Operator Group <span class="text-red-500">*</span>
                        </label>
                        <select id="operatorGroupId" formControlName="operatorGroupId"
                            class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            [class.border-red-500]="isFieldInvalid('operatorGroupId')"
                            [disabled]="!createOperatorForm.get('customerId')?.value">
                            <option value="">Select an operator group</option>
                            @if (loadingGroups()) {
                            <option disabled>Loading groups...</option>
                            }
                            @for (group of operatorGroups(); track group.id) {
                            <option [value]="group.id">{{ group.name }} ({{ group.role }})</option>
                            }
                        </select>
                        @if (isFieldInvalid('operatorGroupId')) {
                        <p class="mt-1 text-sm text-red-600">{{ getFieldError('operatorGroupId') }}</p>
                        }
                        @if (!createOperatorForm.get('customerId')?.value) {
                        <p class="mt-1 text-sm text-gray-500">Please select a customer first</p>
                        }
                    </div>
                </div>
            </div>

            <!-- Personal Information Section -->
            <div class="form-section">
                <h3 class="section-title">Personal Information</h3>

                <div class="form-row">
                    <div class="form-group">
                        <jjames-input formControlName="firstName" label="First Name" placeholder="Enter first name"
                            [required]="true"
                            [errorMessage]="isFieldInvalid('firstName') ? getFieldError('firstName') : ''">
                        </jjames-input>
                    </div>

                    <div class="form-group">
                        <jjames-input formControlName="lastName" label="Last Name" placeholder="Enter last name"
                            [required]="true"
                            [errorMessage]="isFieldInvalid('lastName') ? getFieldError('lastName') : ''">
                        </jjames-input>
                    </div>
                </div>
            </div>

            <!-- Account Information Section -->
            <div class="form-section">
                <h3 class="section-title">Account Information</h3>

                <div class="form-row">
                    <div class="form-group full-width">
                        <jjames-input formControlName="email" label="Email Address" placeholder="Enter email address"
                            type="email" [required]="true"
                            [errorMessage]="isFieldInvalid('email') ? getFieldError('email') : ''">
                        </jjames-input>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group full-width">
                        <jjames-input formControlName="defaultPassword" label="Default Password"
                            placeholder="Enter default password" type="password" [required]="true"
                            [errorMessage]="isFieldInvalid('defaultPassword') ? getFieldError('defaultPassword') : ''">
                        </jjames-input>
                        <div class="field-hint">
                            The operator will need to change this password on first login.
                        </div>
                    </div>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="form-actions">
                <jjames-button type="button" variant="secondary" (click)="onCancel()" [disabled]="isSubmitting">
                    Cancel
                </jjames-button>

                <jjames-button type="submit" variant="primary" [loading]="isSubmitting"
                    [disabled]="!createOperatorForm.valid || isSubmitting">
                    {{ isSubmitting ? 'Creating...' : 'Create Operator' }}
                </jjames-button>
            </div>
        </form>
    </jjames-card>
</div>